import { type ExternalFile, ExternalFileSource } from '@/lib/types';
import { FALLBACK_MIME_TYPE } from '../../utils/constants';

const convertPickerDocumentToExternalFile = (
  pickerDocument: google.picker.DocumentObject,
): ExternalFile | null => {
  const url = pickerDocument[google.picker.Document.URL];
  const filename = pickerDocument[google.picker.Document.NAME];

  if (typeof url === 'undefined' || typeof filename === 'undefined') {
    return null;
  }

  return {
    source: ExternalFileSource.GOOGLE_DRIVE,
    externalId: pickerDocument[google.picker.Document.ID],
    filename,
    url,
    mimeType:
      pickerDocument[google.picker.Document.MIME_TYPE] ?? FALLBACK_MIME_TYPE,
  };
};

export default convertPickerDocumentToExternalFile;
